import * as EmailValidator from 'email-validator';

export function isValidEmail(email: string): boolean {
    return EmailValidator.validate(email)
}

export function isValidPassword(password: string): boolean{
    return password.length > 6; /** let's keep it this minimal for now.. */
}

export const decodeJWT = (token: string) => {
    const parts = token.split('.');
    if (parts.length !== 3) {
      throw new Error('Invalid JWT token');
    }
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const decodedPayload = JSON.parse(atob(payload));
    return decodedPayload;
  };
